<template>
  <section :class="['flats-wrapper']">
    <div
      v-for="flat in flatsList"
      :key="flat.uuid"
      class="appartment-card"
    >
      <div class="preview-demo-flats">
        <img class="image" :src="flat.preview" />
      </div>
      <div class="title">
        {{ translate(flat.name) }}
      </div>
      <div v-if="flat.apartment_type.general" class="meta-info">
        <div class="name-param">
          {{ $t('Floor') }}
        </div>
        <div class="value-param">
          {{ flat.apartment_type.general.floor }}
        </div>
      </div>
      <div v-if="flat.apartment_type.general" class="meta-info">
        <div class="name-param">
          {{ $t('Square') }}
        </div>
        <div class="value-param">
          {{ flat.properties.square }}
        </div>
      </div>
      <div class="action">
        <ui-button
          class="btn"
          :label="$t('open')"
          color="gray"
          @click="
            openDesignVariants(flat.saves, translate(flat.name))
          "
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import type {IApartment, IRealtySaves} from '../api';
import {useLocale} from '~/plugins/Localization';

export default defineComponent({
  name: 'RealtyFlats',
  props: {
    flatsList: {
      required: true,
      type: Array as () => IApartment[],
    },
  },
  setup(props) {
    const locale = useLocale();
    console.debug(props.flatsList);
    const router = useRouter();
    const route = useRoute();
    function translate(name: string) {
      const word = name.split(' ');
      const translated = locale.getRealty(word[0]);
      return translated;
    }
    function openDesignVariants(saves: IRealtySaves, name: string) {
      router.push({
        query: {
          dfdSaves: saves.dfdSave,
          tetriaryRouteName: name,
          secondaryPathName: route.query.secondaryPathName,
          nameRC: route.query.nameRC,
        },
      });
    }
    return {translate, openDesignVariants};
  },
});
</script>
<style lang="scss" scoped>
.flats-wrapper {
  width: 100%;
  max-width: 1128px;
  min-height: 576px;
  margin: 0 auto 0;
  @include grid-card-center;
}
.appartment-card {
  width: 264px;
  height: 312px;
  padding: 18px;
  border-radius: 16px;
  border: 1px solid var(--white-theme-white-400, #e1e5f0);
  background: var(--white-theme-white-200, #f6f8fd);
  display: flex;
  flex-direction: column;
  .preview-demo-flats {
    border-radius: 12px;
    background-color: #839aaf;
    height: 143px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 120px;
    }
  }

  .title {
    color: var(--white-theme-black-100, #3d424a);
    font-family: Segoe UI;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.32px;
    align-items: center;
    position: relative;
    display: flex;
    white-space: nowrap;
    &:after {
      position: absolute;
      right: 0;
      height: 100%;
      width: 50px;
      background: linear-gradient(
        90deg,
        transparent 0,
        var(--bg-quinary) 100%
      );
      content: '';
    }
  }
  .meta-info {
    display: flex;
    margin-top: 4px;

    .name-param {
      margin-right: 24px;
      width: 64px;
      height: 16px;
      color: var(--white-theme-gray-200, #839aaf);
      font-family: Segoe UI;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    .value-param {
      color: var(--white-theme-black-200, #64686e);
      font-family: Segoe UI;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
  .action {
    margin-top: auto;
    padding-top: 16px;
    .btn {
      width: 100%;
    }
  }
}
</style>
